// The only place that knows where the Cognito access token comes from:
// PPCE's own Cognito sign-in (see ./oidc), stored in sessionStorage.
import userManager from './oidc'

// Renew this long before the token actually expires.
const EXPIRY_MARGIN_SECONDS = 60

let pendingRequest = null

const toSession = (user) => {
  if (!user || !user.access_token) {
    return null
  }

  return {
    accessToken: user.access_token,
    expiresAt: user.expires_at * 1000,
    user: {
      sub: user.profile.sub || null,
      email: user.profile.email || null,
    },
  }
}

const renew = async () => {
  try {
    return toSession(await userManager.signinSilent())
  } catch (error) {
    // Refresh token expired or revoked: sign in again.
    await userManager.removeUser()
    return null
  }
}

const requestSession = async () => {
  const user = await userManager.getUser()
  if (!user) {
    return null
  }

  if (user.expires_in > EXPIRY_MARGIN_SECONDS) {
    return toSession(user)
  }

  if (!user.refresh_token) {
    await userManager.removeUser()
    return null
  }

  return renew()
}

// Resolves the current session ({ accessToken, expiresAt, user }) or null when signed out.
export const getSession = () => {
  if (!pendingRequest) {
    pendingRequest = requestSession()
      .finally(() => {
        pendingRequest = null
      })
  }

  return pendingRequest
}

export const clearSession = () => userManager.removeUser()
